import { Loader, PageLayout } from "../../components/index";
import { HomeLanding } from "../home/index";
import MissionVision from "./misionVision/MissionVision";
import AboutImageFloating from "./aboutImageFloating/AboutImageFloating";
import AboutLandScap from "./aboutLandscap/AboutLandScap";
import AboutTitlePara from "./aboutTitlePara/AboutTitlePara";
import Team from "./team/Team";
import VideoLandScap from "./videoLandscap/VideoLandScap";
import { Helmet } from "react-helmet";

import axios from "axios";
import { baseUrl, getAboutPage } from "../../utils/apiData";
import { Fragment, useEffect, useState } from "react";

const About = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({});
  const [team, setTeam] = useState([]);
  const [amenities, setAmenities] = useState([]);

  // Page API Start
  const getAboutApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${getAboutPage}`);
      if (res?.data?.success) {
        setData(res?.data?.data?.aboutPage);
        setTeam(res?.data?.data?.team);
        setAmenities(res?.data?.data?.amenties);
      }
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };
  // Page API End

  useEffect(() => {
    getAboutApi();
  }, []);

  // After 5 second content hide
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    setIsVisible(true);

    const id = setTimeout(() => {
      setIsVisible(false);
    }, 5000);

    return () => {
      clearTimeout(id);
    };
  }, []);

  return (
    <PageLayout>
      <Helmet>
        <title>About | Exotic Group</title>
        <meta name="description" content="About | Exotic Group" />
      </Helmet>
      {loader ? (
        <Loader />
      ) : (
        <Fragment>
          <HomeLanding
            title={isVisible ? data?.title : ""}
            para={isVisible ? data?.description : ""}
            videoId={data?.video}
            isShow={isVisible}
            w={3}
            h={2}
          />
          <div id="second">
            <AboutImageFloating img={`${baseUrl}/${data?.section_1_image}`} />
          </div>

          <AboutTitlePara
            tag={data?.ecosystem_heading}
            title={data?.ecosystem_title}
            para={data?.ecosystem_description}
          />
          <AboutLandScap img={`${baseUrl}/${data?.section_2_image}`} />
          <Team teamData={team} title={data?.team_heading} />
          <MissionVision title={data?.section_3_title} dataList={amenities} />
          <VideoLandScap videoId={data.section_4_video} />
        </Fragment>
      )}
    </PageLayout>
  );
};

export default About;
